<template>
  <v-navigation-drawer v-model="drawer" app>
    <v-list dense>
      <v-list-item v-if="authenticated" link @click="handleDashboardSelected">
        <v-list-item-action>
          <v-icon>mdi-home</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Dashboard</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item v-if="authenticated" link @click="handleLogout">
        <v-list-item-action>
          <v-icon>mdi-logout</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Logout</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item v-if="authenticated">
        <b>Logged in as {{ username }}</b>
      </v-list-item>
      <!-- Global metric/imperial unit selection -->
      <v-list-item>
        <v-subheader>UNITS</v-subheader>
        <v-btn-toggle v-model="numericUnit" tile dense color="primary" mandatory>
          <v-btn value="imperial">Imperial</v-btn>
          <v-btn value="metric">Metric</v-btn>
        </v-btn-toggle>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: 'NavigationDrawer',
  props: {
    openDrawer: {
      type: Boolean,
      default: false,
    },
    authenticated: {
      type: Boolean,
      default: false,
    },
    username: {
      type: String,
      default: '',
    },
    initialNumericUnit: {
      type: String,
      default: null,
    },
  },
  computed: {
    drawer: {
      get() {
        return this.openDrawer;
      },
      set(open) {
        if (!open) {
          this.$emit('onCloseDrawer');
        }
      },
    },
    numericUnit: {
      get() {
        return this.initialNumericUnit;
      },
      set(value) {
        this.$emit('onNumericUnitChanged', value);
      },
    },
  },
  methods: {
    handleDashboardSelected() {
      this.$emit('onDashboardSelected');
    },
    handleLogout() {
      this.$emit('onLogout');
    },
  },
};
</script>
